import React, { useContext } from 'react';
import { Theme } from '../../../../stores/types/themes';
import Icon, { COLORS, ICONS } from '../../../general-components/icon';
import { FormContext } from '../../../../contexts/generated-content/content-form-context';
import classNames from 'classnames';
import { GreenroomState } from '../../../../stores/types/types';
import { useSelector } from 'react-redux';
import { THEME_FILTER } from '../../../../stores/reducers/themes';

interface Props {
	theme: Theme,
	onEdit: (theme: Theme) => void,
	onDelete: (theme: Theme) => void,
	isSelected: boolean;
	isForShotEditorModal?: boolean;
}

export default function ThemeCard(props: Props) {
	const attachedThemes = useSelector((s: GreenroomState) => s.ThemesReducer.attachedThemes);
	const themeFilter = useSelector((s: GreenroomState) => s.ThemesReducer.themeFilter);
	const {id, name, colors} = props.theme;

	const {uniqueId, applyThemeToItem} = useContext(FormContext);
	/*
		any gr_media / gr_graphics that is a stylepack asset maps to a gr_generated_content with fkId and fkTable -> gr_generated_content.themeId
	*/
	const currentGraphicId = useSelector((s: GreenroomState) => s.GraphicsReducer.currentGraphicId);

	const select = () => {
		applyThemeToItem(props.theme)
	}
	const edit = (e: React.MouseEvent) => {
		e.stopPropagation();
		e.preventDefault();
		props.onEdit(props.theme)
	}
	const deleteTheme = (e: React.MouseEvent) => {
		e.stopPropagation();
		e.preventDefault();
		props.onDelete(props.theme)
	}

	const isSelected = React.useMemo(() => {
		if (attachedThemes && uniqueId in attachedThemes) {
			return attachedThemes[uniqueId] === id;
		} else {
			return !!props.isSelected;
		}
	}, [uniqueId, attachedThemes, props.isSelected, id]);
	
	return (<div 
			onClick={select}
			className={classNames('theme-card justify-content-space-between', {
				selected: isSelected
			})}
		>
			<div className='margin-right-auto bl-font-s1'>{name}</div>
			<div className='flex'>
				{colors.map((hex, index) => index > 2 ? null : <div 
					key={`${hex}+${index}`}
					className={classNames('theme-card-swatch', { 'shot-modal': props.isForShotEditorModal })}
					style={{backgroundColor: hex}}/>
				)}
				{!props.isForShotEditorModal && (
					<div className='theme-card-edit-hover flex'>
						{themeFilter !== THEME_FILTER.CUSTOM ? null 
							: <div className='edit-button corner-round-massive margin-right-extra-small' onClick={deleteTheme}>
								<Icon name={ICONS.TRASH} size={12} color={COLORS.WHITE}/>
							</div>}
						<div className='edit-button corner-round-massive' onClick={edit}>
							<Icon name={ICONS.EDIT} size={12} color={COLORS.WHITE}/>
						</div>
					</div>
				)}
			</div>
		</div>
	);
}
